import {values, any} from 'ramda';

import {getSafely, isNotNilOrEmpty} from 'shared/web';

type ObjectWithValue = {value: unknown};

const VALUE_KEY = 'value';

const hasValue = (item: unknown): item is ObjectWithValue =>
  typeof item === 'object' &&
  item !== null &&
  VALUE_KEY in item &&
  isNotNilOrEmpty(getSafely(item, VALUE_KEY));

export function hasNestedData<T extends Record<string, unknown>>(obj: T) {
  return any(hasValue)(values(obj));
}
